export const common = {
	//Menu
	"menu.play": "Spielen",
	"menu.ranking": "Rangliste",
	"menu.prizes": "Preise",
	"menu.rules": "Regeln",
	"menu.leagues": "Ligen",
	"menu.betwayAccount": "Betway Konto",
	"menu.terms": "AGB",

	//Play
	"play.heroTitle": "Sage jedes Spielergebnis voraus und gewinne Preise!",
	"play.heroSubtitle": "Welches Team wird gewinnen? Wie viele Tore werden sie schießen? Sage es jetzt voraus und tritt gegen deine Freunde an!",
	"play.playNow": "Jetzt spielen",
	"play.seePrizes": "Preise ansehen",
	"play.statistics": "Statistiken",
	"play.lastMatches": "Die letzten 5 Spiele jedes Teams",
	"play.stats": "Statistiken",

	//Ranking
	"ranking.season": "Saison",
	"ranking.weekly": "Wöchentlich",
	"ranking.selectType": "Ranglistentyp auswählen",
	"ranking.selectWeek": "Woche auswählen",
	"ranking.myPosition": "Meine Position",
	"ranking.points": "Punkte",
	"ranking.rank": "Rang",
	"ranking.topMembers": "Top Mitglieder",
	"ranking.noRanking": "Noch keine Rangliste.",
	"ranking.competitionStart": "Sobald der Wettbewerb beginnt, werden alle Benutzer, die BW Fantasy Football gespielt haben, hier eingestuft.",
	"ranking.loadMore": "Mehr laden",
	"ranking.loading": "Lädt...",

	//Leagues
	"leagues.heroTitle": "Tritt gegen deine Freunde an oder tritt öffentlichen Ligen bei!",
	"leagues.heroSubtitle": "Wer hat die besten Vorhersagefähigkeiten? Erstelle oder tritt einer Liga bei, um es herauszufinden!",
	"leagues.createLeague": "Liga erstellen",
	"leagues.joinLeague": "Liga beitreten",
	"leagues.createLeagueButton": "Liga erstellen",
	"leagues.joinLeagueButton": "Liga beitreten",
	"leagues.enterName": "Liga-Namen eingeben",
	"leagues.enterCode": "Einladungscode eingeben",
	"leagues.myLeagues": "Meine Ligen",
	"leagues.member": "Mitglied",
	"leagues.members": "Mitglieder",
	"leagues.membersCapital": "Mitglieder",
	"leagues.league": "Liga",
	"leagues.shareCodeText": "Deine Freunde können deiner Liga mit diesem Code beitreten:",
	"leagues.shareCode": "Code teilen",
	"leagues.editLeague": "Liga bearbeiten",
	"leagues.delete": "Löschen",
	"leagues.leave": "Verlassen",
	"leagues.deleteWarning": "Alle Verlaufsdaten und Mitglieder werden dauerhaft gelöscht.",
	"leagues.leaveWarning": "Deine Vorhersagepunkte und Ranglistenposition werden gelöscht.",
	"leagues.confirmDelete": "Ja, löschen",
	"leagues.confirmLeave": "Ja, verlassen",
	"leagues.cancel": "Abbrechen",
	"leagues.ban": "Sperren",
	"leagues.edit": "Bearbeiten",
	"leagues.save": "Speichern",

	//Errors
	"errors.savingPredictions": "Fehler beim Speichern der Vorhersagen",

	//Predictions
	"predictions.successModal.title": "Vorhersagen bestätigt!",
	"predictions.successModal.subtitle": "Deine Vorhersagen wurden erfolgreich gespeichert!",
	"predictions.successModal.close": "Schließen",
	"predictions.seasonEnd.title": "Saison beendet!",
	"predictions.seasonEnd.message":
		"Das war's für diese Saison von BW Fantasy Football — gut gemacht! Herzlichen Glückwunsch an unseren Hauptpreisgewinner, [username], der eine Reise für zwei Personen gewonnen hat, um Arsenal live im Emirates Stadium zu sehen. Während die Action eine kurze Pause einlegt, bereiten wir uns bereits auf die nächste Runde vor. Bleib dran für Updates und bereite dich darauf vor, mit noch schärferen Vorhersagen zurückzukommen.",
	"predictions.seasonEnd.subtitle": "Wir können es kaum erwarten, dich wieder im Spiel zu haben!",
	"predictions.seasonEnd.myPosition": "Meine Position",
	"predictions.seasonEnd.points": "Punkte",
	"predictions.seasonEnd.rank": "Rang",
	"predictions.seasonEnd.topMembers": "Top 10 Mitglieder",
	"predictions.countdown.deadline": "Frist",
	"predictions.countdown.deadlineMissed": "Frist verpasst",
	"predictions.countdown.matchweekDeadline": "Spieltag-Frist",
	"predictions.countdown.deadlineMissedMessage":
		"Du hast deine Vorhersagen für diese Woche nicht gemacht, daher wurden keine Punkte verdient - aber es gibt immer nächste Woche, um zurückzukommen!",
	"predictions.countdown.days": "TAGE",
	"predictions.countdown.hours": "STUNDEN",
	"predictions.countdown.minutes": "MIN.",
	"predictions.countdown.seconds": "SEK.",
	"predictions.bonusFooter.loadingOdds": "Lade Quoten...",
	"predictions.bonusFooter.draw": "Unentschieden",
	"predictions.bonusFooter.unknown": "Unbekannt",
	"predictions.bonusFooter.oddsToWin": "Gewinnquoten",
	"predictions.roundSelector.previousRound": "Vorherige Runde",
	"predictions.roundSelector.nextRound": "Nächste Runde",
	"predictions.points.totalPoints": "Gesamtpunkte",
	"predictions.points.currentPosition": "Aktuelle Position",
	"predictions.points.points": "Punkte",
	"predictions.points.totalPointsLabel": "Gesamtpunkte",
	"predictions.submitButton.submitting": "Wird übermittelt...",
	"predictions.submitButton.predictionsSaved": "Vorhersagen gespeichert",
	"predictions.submitButton.updatePredictions": "Vorhersagen aktualisieren",
	"predictions.submitButton.submitAllPredictions": "Alle Vorhersagen übermitteln",
	"predictions.predictionCard.result": "Ergebnis",
	"predictions.predictionCard.pts": "Pkt",

	//Common Components
	"common.shareCard.title": "Lade deine Freunde zum Spielen ein",
	"common.shareCard.description":
		"Lade deine Freunde ein, BW Fantasy Football zu spielen, um zu sehen, wer von euch der beste Fußballmanager ist, und damit ihr alle die Chance habt, wöchentliche Preise zu gewinnen!",
	"common.shareCard.button": "Freunde einladen",
	"common.shareCard.shareTitle": "BetwayScores herunterladen",
	"common.shareCard.shareBody": "Lade BetwayScores herunter und tritt gegen deine Freunde in BW Fantasy Football an!",

	"common.accessDenied.title": "Betway Scores App herunterladen",
	"common.accessDenied.description":
		"Um auf diesen Inhalt zuzugreifen, lade bitte die Betway Scores App herunter. Erhalte die neuesten Ergebnisse, Vorhersagen und exklusive Funktionen direkt zur Hand.",
	"common.accessDenied.rulesText": "Verfügbar für iOS- und Android-Geräte. Jetzt herunterladen, um loszulegen!",
	"common.accessDenied.button": "Betway Scores App herunterladen",

	"common.prizesInfoCard.title": "Informationen zu Preisen",
	"common.prizesInfoCard.description1":
		"Du benötigst kein Betway-Konto, um BW Fantasy Football zu spielen. Um jedoch einen wöchentlichen Preis für einen Platz in den Top 10 einer Woche einzulösen, benötigst du ein Betway-Konto, auf das diese Gewinne eingezahlt werden können.",
	"common.prizesInfoCard.description2": "Siehe die Regeln und AGB des Spiels für Details zu den wöchentlichen und Gesamtpreisen.",
	"common.prizesInfoCard.button": "Regeln ansehen",

	//Prizes Fragment
	"prizes.prizeCard1.title": "Hauptpreis – Arsenal im Emirates Stadium schauen",
	"prizes.prizeCard1.description":
		"Gewinne eine Reise für zwei Personen, um Arsenal im Emirates Stadium in London spielen zu sehen, einschließlich Flüge (falls erforderlich), Unterkunft (falls erforderlich) und £500 Taschengeld.",
	"prizes.prizeCard2.title": "Rundensieger – Geldpreis in deinem Betway-Konto",
	"prizes.prizeCard2.description":
		"Der beste Spieler jeder Woche gewinnt €150 (oder Währungsäquivalent – siehe Abschnitt 'Regeln') als Bargeld, das auf sein Betway-Konto eingezahlt wird.",
	"prizes.prizeCard3.title": "Plätze 2-10 jede Runde – Geldpreis in deinem Betway-Konto",
	"prizes.prizeCard3.description":
		"Diejenigen, die jede Woche auf den Plätzen 2 bis 10 landen, erhalten ebenfalls Geldpreise auf ihr Betway-Konto. Siehe den Abschnitt 'Regeln' für die genauen Beträge, die du gewinnen kannst.",

	"common.modal.pointsFormat": "+{points}Pkt",

	//Betway Account Fragment
	"betwayAccount.title": "Betway-Konto eröffnen",
	"betwayAccount.description":
		"Du benötigst kein Betway-Konto, um BW Fantasy Football zu spielen. Um jedoch einen wöchentlichen Preis für einen Platz in den Top 10 einer Woche einzulösen, benötigst du ein Betway-Konto, auf das diese Gewinne eingezahlt werden können.",
	"betwayAccount.rulesText": "Siehe die Regeln und AGB des Spiels für Details zu den wöchentlichen und Gesamtpreisen.",
	"betwayAccount.button": "Betway-Konto eröffnen",
};
